import { render, staticRenderFns } from "./RequestTab.vue?vue&type=template&id=7f05fcaa"
import script from "./js/requestTab.js?vue&type=script&lang=js&external"
export * from "./js/requestTab.js?vue&type=script&lang=js&external"
import style0 from "./RequestTab.vue?vue&type=style&index=0&id=7f05fcaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports